import { API_BASE } from '../../../api';

export const ENDPOINTS = {
   noticias: `${API_BASE}/Noticias`,
   noticiasById: (id) => `${API_BASE}/Noticias/${id}`,
   noticiasDashboardByUsuarioId: (id) => `${API_BASE}/Noticias/dashboard/${id}`,

   empresasDescendientes: (idPadre) => `${API_BASE}/Empresas/descendientes/${idPadre}`,
   noticiasCompartidas: `${API_BASE}/NoticiasCompartidas`,
   noticiasCompartidasByNoticia: (id) => `${API_BASE}/NoticiasCompartidas/noticia/${id}`,

   noticiasLecturas: `${API_BASE}/NoticiasLecturas`,
   noticiasLecturasById: (id) => `${API_BASE}/NoticiasLecturas/${id}`,

   avisos: `${API_BASE}/Avisos`,
   avisosById: (id) => `${API_BASE}/Avisos/${id}`,
   avisosDashboardByUsuarioId: (id) => `${API_BASE}/Avisos/dashboard/${id}`,
   avisosCompartidos: `${API_BASE}/AvisosCompartidos`,
   avisosCompartidosByAviso: (id) => `${API_BASE}/AvisosCompartidos/aviso/${id}`,

   articulos: `${API_BASE}/Articulos`,
   articulosById: (id) => `${API_BASE}/Articulos/${id}`,
   articulosDashboardByUsuarioId: (id) => `${API_BASE}/Articulos/dashboard/${id}`,
   articulosCompartidos: `${API_BASE}/ArticulosCompartidos`,
   articulosCompartidosByArticulo: (id) => `${API_BASE}/ArticulosCompartidos/articulo/${id}`,

   documentos: `${API_BASE}/Documentos`,
   documentosById: (id) => `${API_BASE}/Documentos/${id}`,
   documentosDashboardByUsuarioId: (id) => `${API_BASE}/Documentos/dashboard/${id}`,

   documentoArea: `${API_BASE}/DocumentoArea`,
   gestorDocumental: `${API_BASE}/GestorDocumental`,

   foros: `${API_BASE}/Foros`,
   forosById: (id) => `${API_BASE}/Foros/${id}`,
   forosDashboardByUsuarioId: (id) => `${API_BASE}/Foros/dashboard/${id}`,
   forosCompartidos: `${API_BASE}/ForosCompartidos`,
   forosCompartidosByForo: (id) => `${API_BASE}/ForosCompartidos/foro/${id}`,

   forosRespuestas: `${API_BASE}/ForosRespuestas`,
   forosRespuestasById: (id) => `${API_BASE}/ForosRespuestas/${id}`,

   eventos: `${API_BASE}/Eventos`,
   eventosById: (id) => `${API_BASE}/Eventos/${id}`,
   eventosDashboardByUsuarioId: (id) => `${API_BASE}/Eventos/dashboard/${id}`,
   eventosCompartidos: `${API_BASE}/EventosCompartidos`,
   eventosCompartidosByEvento: (id) => `${API_BASE}/EventosCompartidos/evento/${id}`,

   categorias: `${API_BASE}/Categorias`,
   categoriasById: (id) => `${API_BASE}/Categorias/${id}`,

   estadosIntranet: `${API_BASE}/EstadosIntranet`,
   estadosIntranetById: (id) => `${API_BASE}/EstadosIntranet/${id}`,

   sugerencias: `${API_BASE}/Sugerencias`,
   sugerenciasById: (id) => `${API_BASE}/Sugerencias/${id}`,
   sugerenciasDashboardByUsuarioId: (id) => `${API_BASE}/Sugerencias/dashboard/${id}`,
   sugerenciasPorUsuario: (id) => `${API_BASE}/Sugerencias/usuario/${id}`,

   encuestas: `${API_BASE}/Encuestas`,
   encuestasById: (id) => `${API_BASE}/Encuestas/${id}`,
   encuestasDashboardByUsuarioId: (idUsuario) => `${API_BASE}/Encuestas/dashboard/${idUsuario}`,
   encuestasCompartidas: `${API_BASE}/EncuestasCompartidas`,
   encuestasCompartidasByEncuesta: (id) => `${API_BASE}/EncuestasCompartidas/encuesta/${id}`,


   encuestaIntentos: `${API_BASE}/EncuestaIntentos`,
   encuestaIntentosById: (id) => `${API_BASE}/EncuestaIntentos/${id}`,

   encuestaPreguntas: `${API_BASE}/EncuestaPreguntas`,
   encuestaPreguntasById: (id) => `${API_BASE}/EncuestaPreguntas/${id}`,

   encuestaPreguntaOpcionMultiple: `${API_BASE}/EncuestaPreguntaOpcionMultiple`,
   encuestaPreguntaOpcionMultipleById: (id) => `${API_BASE}/EncuestaPreguntaOpcionMultiple/${id}`,

   encuestaPreguntaVerdaderoFalso: `${API_BASE}/EncuestaPreguntaVerdaderoFalso`,
   encuestaPreguntaVerdaderoFalsoById: (id) => `${API_BASE}/EncuestaPreguntaVerdaderoFalso/${id}`,

   encuestaRespuestas: `${API_BASE}/EncuestaRespuestas`,
   encuestaRespuestasById: (id) => `${API_BASE}/EncuestaRespuestas/${id}`,

   encuestaRespuestaOpcionMultipleOpciones: `${API_BASE}/EncuestaRespuestaOpcionMultipleOpciones`,
   encuestaRespuestaOpcionMultipleOpcionesById: (id) => `${API_BASE}/EncuestaRespuestaOpcionMultipleOpciones/${id}`,

   encuestaRespuestaTextoLibre: `${API_BASE}/EncuestaRespuestaTextoLibre`,
   encuestaRespuestaTextoLibreById: (id) => `${API_BASE}/EncuestaRespuestaTextoLibre/${id}`,

   respuestaEncuestaOpcionMultipleDet: `${API_BASE}/RespuestaEncuestaOpcionMultipleDet`,
   respuestaEncuestaOpcionMultipleDetById: (id) => `${API_BASE}/RespuestaEncuestaOpcionMultipleDet/${id}`,

   respuestaEncuestaTextoLibre: `${API_BASE}/RespuestaEncuestaTextoLibre`,
   respuestaEncuestaTextoLibreById: (id) => `${API_BASE}/RespuestaEncuestaTextoLibre/${id}`,

   respuestaEncuestaVerdaderoFalso: `${API_BASE}/RespuestaEncuestaVerdaderoFalso`,
   respuestaEncuestaVerdaderoFalsoById: (id) => `${API_BASE}/RespuestaEncuestaVerdaderoFalso/${id}`,

   catTiposPregunta: `${API_BASE}/CatTiposPregunta`,
   catTiposPreguntaById: (id) => `${API_BASE}/CatTiposPregunta/${id}`,

   // General (copias para independencia de módulo)
   areasNegocios: `${API_BASE}/AreasNegocio`,
   areasNegociosById: (id) => `${API_BASE}/AreasNegocio/${id}`,
   areasNegociosByEmpresaUsuarioId: (id) => `${API_BASE}/AreasNegocio/empresa/${id}`,

   empleados: `${API_BASE}/Empleados`,
   empleadosById: (id) => `${API_BASE}/Empleados/${id}`,

   empleadosAreaNegocio: `${API_BASE}/EmpleadosAreaNegocio`,
   empleadosAreaNegocioById: (id) => `${API_BASE}/EmpleadosAreaNegocio/${id}`,

   personas: `${API_BASE}/Personas`,
   personasById: (id) => `${API_BASE}/Personas/${id}`,
   personasByUsuarioId: (idUsuario) => `${API_BASE}/Personas/usuario/${idUsuario}`,
   personasCumpleanosDashboardByUsuarioId: (id) => `${API_BASE}/Personas/dashboard/cumpleanos/${id}`,

   usuarios: `${API_BASE}/Usuarios`,
   usuarioById: (id) => `${API_BASE}/Usuarios/${id}`,

   correoPlantilla: `${API_BASE}/CorreoPlantillaIntranet`,
   correoPlantillaById: (id) => `${API_BASE}/CorreoPlantillaIntranet/${id}`,
   enviarCorreoPlantilla: (id) => `${API_BASE}/CorreoPlantillaIntranet/enviar/${id}`,
   enviarMasivoCorreoPlantilla: (id) => `${API_BASE}/CorreoPlantillaIntranet/enviar-masivo/${id}`,
};
